import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, SERVICES } from "../data/content";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[var(--navy-deeper)] text-white relative overflow-hidden"
    >
      <div className="container-x py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="eyebrow text-[var(--copper)] mb-4">Est. {COMPANY.founded}</div>
          <h3 className="font-serif-display text-3xl md:text-4xl leading-tight mb-6">
            Admiral Roofing
            <br />
            <span className="text-white/60">&amp; Home Improvement</span>
          </h3>
          <p className="text-white/70 max-w-md leading-relaxed text-sm">
            A family-run roofing & home improvement company based in Braintree,
            MA — protecting South Shore homes for over three decades. Same
            standards. Same crews.
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta-estimate"
            className="btn-copper mt-8"
          >
            Get a Free Estimate
          </Link>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow mb-5">Services</div>
          <ul className="space-y-3 text-sm text-white/80">
            {SERVICES.slice(0, 5).map((s) => (
              <li key={s.id}>
                <Link
                  to="/"
                  data-testid={`footer-service-${s.id}`}
                  className="hover:text-[var(--copper)] transition-colors"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow mb-5">Contact</div>
          <ul className="space-y-4 text-sm text-white/80">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-1 shrink-0 text-[var(--copper)]" />
              <span data-testid="footer-address">{COMPANY.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="shrink-0 text-[var(--copper)]" />
              <a
                href={`tel:${COMPANY.phoneTel}`}
                data-testid="footer-phone"
                className="hover:text-[var(--copper)]"
              >
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="shrink-0 text-[var(--copper)]" />
              <a
                href={`mailto:${COMPANY.email}`}
                data-testid="footer-email"
                className="hover:text-[var(--copper)]"
              >
                {COMPANY.email}
              </a>
            </li>
          </ul>

          <div className="eyebrow mt-8 mb-3">Hours</div>
          <ul className="space-y-1.5 text-sm text-white/70">
            {COMPANY.hours.map((h) => (
              <li key={h.day} className="flex justify-between border-b border-white/10 py-1.5">
                <span>{h.day}</span>
                <span>{h.time}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
          <div data-testid="footer-copyright">
            © {new Date().getFullYear()} {COMPANY.name}. Licensed &amp; Insured in Massachusetts.
          </div>
          <div className="flex gap-6 uppercase tracking-[0.2em]">
            <span>MA HIC #168432</span>
            <span>MA CSL #102998</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
